
<section>
    <app-static-header></app-static-header>
</section>
<section>
    <!-- <div class="banner_div_slider">
        <div id="carouselExampleIndicators1" class="carousel slide desktop_viwe_banner">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3"
                    aria-label="Slide 4"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/desktop_banner/Admission.jpg" width="100%" routerLink="/admissions" loading="lazy" class="d-block slider_img responsive" alt="admissions">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/MenFranchise.jpg" width="100%" routerLink="/partner-with-kidzee" loading="lazy" class="d-block slider_img responsive" alt="partner-with-kidzee">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/WomenFranchise.jpg" width="100%" routerLink="/partner-with-kidzee" loading="lazy" class="d-block pentamind_img responsive" alt="partner-with-kidzee">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/Pentemind.jpg" width="100%" routerLink="/pentemind" loading="lazy" class="d-block pentamind_img responsive" alt="pentemind">
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>

        <div id="carouselExampleIndicators11" class="carousel slide mobile_banner">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="3"
                    aria-label="Slide 4"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/desktop_banner/mobile_banner/Admission_responsive.jpg" width="100%" routerLink="/admissions" loading="lazy" class="d-block slider_img responsive" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/mobile_banner/Men_responsive.jpg" width="100%" routerLink="/partner-with-kidzee" loading="lazy" class="d-block slider_img responsive" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/mobile_banner/Women_responsive.jpg" width="100%" routerLink="/partner-with-kidzee" loading="lazy" class="d-block pentamind_img responsive" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/desktop_banner/mobile_banner/Pentemind_responsive.jpg" width="100%" routerLink="/pentemind" loading="lazy" class="d-block pentamind_img responsive" alt="...">
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators11"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators11"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div> -->


    <div class="banner_content_slider">
        <div id="carouselExampleControls" class="carousel slide">
            <div class="carousel-inner carousel-bg">
              <div class="carousel-item active">
                <img src="../../../assets/img/new-kidzee/banner/home_header.png" class="d-block img-fluid slider_banner" alt="...">
               <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open">
                Admission Open
            </div>
            <img src="../../../assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt="">
                <img src="../../../assets/img/new-kidzee/home_page_girl.png" class="home_girl_img" alt="">
              </div>
              <div class="carousel-item">
                <img src="../../../assets/img/new-kidzee/banner/home_header.png" class="d-block img-fluid slider_banner" alt="...">
                <img src="../../../assets/img/new-kidzee/home_page_girl.png" class="home_girl_img" alt="">  
            </div>
              <div class="carousel-item">
                <img src="../../../assets/img/new-kidzee/banner/home_header.png" class="d-block img-fluid slider_banner" alt="...">
                <img src="../../../assets/img/new-kidzee/home_page_girl.png" class="home_girl_img" alt="">
            </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          
    </div>
    <div class="mobile_res">
        <div id="carouselExampleControls1" class="carousel slide">
            <div class="carousel-inner carousel-bg">
              <div class="carousel-item active">
                <img src="../../../assets/img/new-kidzee/mobile_home_banner.png" class="d-block img-fluid slider_banner" alt="...">
               <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open">
                Admission Open
            </div>
            <div class="d-flex justify-content-center">
            <img src="../../../assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt="">
        </div>
              </div>

              <div class="carousel-item">
                <img src="../../../assets/img/new-kidzee/mobile_home_banner.png" class="d-block img-fluid slider_banner" alt="...">
               <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open">
                Admission Open
            </div>
            <div class="d-flex justify-content-center">
            <img src="../../../assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt="">
        </div>
              </div>
             
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          
    </div>

</section>
<section>
    <div class="mainDiv">
        <app-home-about-us></app-home-about-us>
    </div>
</section>
<section>
<app-programmes></app-programmes>
</section>
<section>
    <img src="../../../assets/img/new-kidzee/day_care_bg_img.png" class="day_care_bg" alt="">
    <img src="../../../assets/img/new-kidzee/day_care_mobile_res_bg.png" class="day_care_bg_mobile" alt="">
    <div class="mainDiv2">
        <div class="dayCareContent">
            <div class="row">
                <div class="col-md-6">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title day_care_color">
                                DayCare
                            </h1>
                            <div class="subTitle white_color">
                                Kidzee Daycare -<br> A home away from home for<br> your child!
                            </div>
                        <div class="infoContent mt-3">
                            <div class="text1">
                                <div class="sub_text">Age Group</div>
                                <div class="sub_text">1.5 - 10 Years</div>
                            </div>
                            <div class="text2">
                                <div class="sub_text">Duration</div>
                                <div class="sub_text">Flexible hours</div>
                            </div>
                        </div>
                            <div class="paragraph_content mt-2 white_color">
                                <p>NEP 2020 has clearly identified child devlopment goals before the child enters a preschool. The Kidzee day care assists parents in addressing these needs.  We understand that the early years in the child’s life are important for the overall development. The primary role of parents in these years is to provide their children with an environment that is  loving, caring, fun-filled and one which provides happy experiences. As these aspects play a very important role in fostering the developmental areas, like, cognitive development, physical development, socio-emotional development, and so on. Hence, our objective is to create a home away from home for them to feel safe, secure and happy. A constructive blend of Care and Devleopment.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="dayCardImg">
                        <div class="">
                            <img srcset="../../../assets/img/new-kidzee/day_care_chaild.png" loading="lazy" alt="Kidzee Daycare" class="schoolGirlImg responsive"
                                align="center">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="mainDiv3">
        <img srcset="../../../assets/img/new-kidzee/baloon.png" class="baloon_img_content" alt="">
        <img srcset="../../../assets/img/new-kidzee/more_fish.png" class="more_fish_content" alt="">
        <div class="pentemindGroup">
            <div class="d-flex justify-content-center">
                <img src="../../../assets/img/new-kidzee/pantamind_new_img.png" loading="lazy" class="pentemindgroupImg responsive" align="center" alt="pentemind">
            </div>
            <img src="../../../assets/img/new-kidzee/bird.png" class="bird_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/circal.png" class="circal_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/right_circal.png" class="right_circal_img_content" alt="">
        </div>
    </div>
</section>
<section>
    <div class="mainDiv4">
        <app-kidzee-pree-school></app-kidzee-pree-school>
    </div>
</section>
<section>
    <div class="mainDiv21">
        <div class="dayCareContent1">
            <div class="row flex-column-reverse flex-lg-row">
                <!-- <div class="col-md-6">
                    <div class="dayCardImg">
                        <div class="">
                            <img srcset="../../../assets/img/childGroup.png" loading="lazy" alt="" class="franchiseImg responsive"
                                align="center" alt="Franchise Opportunity">
                        </div>
                    </div>
                </div> -->
                <div class="col-md-12">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title text-center">
                               <span style="color:#6D2A93;"> Franchise</span> <span class="white_color mx-2">Opportunity</span>
                            </h1>
                            <div class="subTitle text-center">
                                Start your own Preschool, today!
                            </div>
                            <div class="paragraph_content mt-2">
                                <p class="text-center count_color">2,000+ CENTRES | 750+ CITIES</p>
                                <div class="row para_text">
                                    <div class="col-md-2 border_left">
                                        <p>India's largest preschool chain</p>
                                    </div>
                                    <div class="col-md-3 border_left">
                                        <p>Market leader with a strong brand recall & brand lineage of 20+ years</p>
                                    </div>
                                    <div class="col-md-2 border_left">
                                        <p>Proven business model</p>
                                    </div>
                                    <div class="col-md-2 border_left">
                                        <p>Best-in class pedagogy</p>
                                    </div>
                                    <div class="col-md-3" style="color: #6D2A93;">
                                        <p>Comprehensive support including operational, academic, training, and project support</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<section>
    <div class="mainDiv5">
        <app-faqs ></app-faqs>
    </div>
</section>
<section>
    <div class="mainDiv6">
        <div class="blogsContent">
            <app-blogs></app-blogs>
        </div>
    </div>
</section>
<section>
    <div class="mainDiv7">
        <app-testimonial></app-testimonial>
    </div>
</section>
<section>
    <div class="happyParents">
        <!-- <img src="../../../assets/img/new-kidzee/happy_parants_bg.png" width="100%" alt=""> -->
        <div class="slider_content">
            <h1 class="title text-center day_care_color">Our happy parents</h1>
            <div class="cascade-slider_container" id="cascade-slider">
                <div class="cascade-slider_slides">
                  <div class="cascade-slider_item">
                   <div class='card align'>
                <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
              <div class="profile_inf">
                <div class="profile_title text-white">
                   <h5> Namrata Shastri</h5> 
             </div>
                <div>
                    <!-- <p class="text-white">Our Heartfelt Gratitude To Kidzee Hyderabad For Providing Our Kids A Home Away Home To Facilitate Their Growth And Development</p> -->
                </div>
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                  <div class="cascade-slider_item">
                   <div class='card align'>
                    <img src="../../../assets/img/new-kidzee/woman.png" width="100%" alt="">
              </div>
                  </div>
                </div>
                
                <span class="cascade-slider_arrow cascade-slider_arrow-left" data-action="prev"><img src="../../../assets/img/new-kidzee/prev.png"></span>
                <span class="cascade-slider_arrow cascade-slider_arrow-right" data-action="next"><img src="../../../assets/img/new-kidzee/next.png" type="image/svg+xml"></span>
              </div>
        </div>
    </div>
</section>
<app-footer></app-footer>

